export const getElementProp = name => element => {
  return element?.props[name];
};
export const getDataRange = ({
  highlighted,
  firstInHighlightedRange,
  lastInHighlightedRange
}) => {
  if (firstInHighlightedRange) {
    return 'beginning';
  }
  if (lastInHighlightedRange) {
    return 'end';
  }
  if (highlighted) {
    return 'between';
  }
};